(function () {
  'use strict';

  var STORAGE_KEY = 'tenez:checked-products';
  var MAX_ITEMS = 12;

  var storageEnabled = isStorageAvailable();

  function isStorageAvailable() {
    try {
      var testKey = '__checked_products_test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      console.warn('[checked-products] localStorage unavailable', error);
      return false;
    }
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getStoredItems() {
    if (!storageEnabled) return [];
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('[checked-products] Failed to parse storage', error);
      return [];
    }
  }

  function saveItems(items) {
    if (!storageEnabled) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.warn('[checked-products] Failed to persist storage', error);
    }
  }

  function parseCurrentProduct() {
    var script = document.querySelector('script[data-recently-viewed-product]');
    if (!script) return null;

    try {
      var data = JSON.parse(script.textContent.trim());
      data.recordedAt = Date.now();
      return data;
    } catch (error) {
      console.warn('[checked-products] Invalid product payload', error);
      return null;
    }
  }

  function recordCurrentProduct() {
    if (!storageEnabled) return;
    var product = parseCurrentProduct();
    if (!product || !product.id) return;

    var items = getStoredItems();
    var existingIndex = items.findIndex(function (entry) {
      return entry && entry.id === product.id;
    });
    if (existingIndex > -1) {
      items.splice(existingIndex, 1);
    }
    items.unshift(product);
    if (items.length > MAX_ITEMS) {
      items = items.slice(0, MAX_ITEMS);
    }
    saveItems(items);
  }

  function renderAllSections() {
    var sections = document.querySelectorAll('[data-checked-products]');
    if (!sections.length) return;

    var items = getStoredItems();
    sections.forEach(function (section) {
      renderSection(section, items);
    });
  }

  function renderSection(section, items) {
    if (!section) return;
    var limit = parseInt(section.dataset.limit || MAX_ITEMS, 10);
    if (!Number.isFinite(limit) || limit <= 0) {
      limit = MAX_ITEMS;
    }
    var grid = section.querySelector('[data-checked-products-grid]');
    var fallback = section.querySelector('[data-checked-products-fallback]');
    if (!grid) return;

    var subset = items.slice(0, limit);
    if (!subset.length) {
      grid.hidden = true;
      if (fallback) fallback.hidden = true;
      section.hidden = true;
      section.classList.remove('checked-products--has-recent');
      section.classList.add('checked-products--hidden');
      return;
    }

    section.hidden = false;
    section.classList.remove('checked-products--hidden');
    section.classList.add('checked-products--has-recent');
    grid.hidden = false;
    if (fallback) fallback.hidden = true;
    grid.innerHTML = '';

    var cardPromises = subset.map(function (item) {
      return fetchCardMarkup(item, section).catch(function () {
        return buildCard(item, section);
      });
    });

    Promise.all(cardPromises).then(function (cards) {
      cards.forEach(function (card) {
        if (card) {
          grid.appendChild(card);
        }
      });
    });
  }

  function fetchCardMarkup(item, section) {
    if (!item) return Promise.resolve(null);
    if (!window.fetch) return Promise.resolve(buildCard(item, section));

    var viewName = (section && section.dataset && section.dataset.cardView) || 'checked-products-card';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var baseUrl = '';
    if (item.handle) {
      baseUrl = root.replace(/\/?$/, '/') + 'products/' + item.handle;
    } else if (item.url) {
      baseUrl = item.url;
    }
    if (!baseUrl) return Promise.resolve(buildCard(item, section));
    var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
    var requestUrl = baseUrl + separator + 'view=' + encodeURIComponent(viewName);

    return fetch(requestUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('[checked-products] Failed to load card HTML');
        }
        return response.text();
      })
      .then(function (html) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var card = wrapper.firstElementChild;
        if (!card) return null;

        var gridItem = document.createElement('div');
        gridItem.className = 'grid__item';
        gridItem.appendChild(card);
        return gridItem;
      });
  }

  function buildCard(item, section) {
    if (!item || !item.url) return null;
    var gridItem = document.createElement('div');
    gridItem.className = 'grid__item';

    var wrapper = document.createElement('div');
    wrapper.className = 'card-wrapper product-card-wrapper underline-links-hover';

    var cardStyle = section.dataset.cardStyle || 'card';
    var card = document.createElement('div');
    card.className = [
      'card',
      'card--' + cardStyle,
      'card--media',
      'card--extend-height',
    ].join(' ');
    if (cardStyle === 'card') {
      card.classList.add('color-' + (section.dataset.cardColorScheme || 'background-1'), 'gradient');
    }

    var inner = document.createElement('div');
    inner.className = 'card__inner ratio';
    if (cardStyle === 'standard') {
      inner.classList.add('color-' + (section.dataset.cardColorScheme || 'background-1'), 'gradient');
    }
    var ratio = parseFloat(item.image_aspect_ratio);
    if (!ratio || !isFinite(ratio)) {
      ratio = 1;
    }
    inner.style.setProperty('--ratio-percent', (1 / ratio) * 100 + '%');

    var media = document.createElement('div');
    media.className = 'card__media';
    var mediaContainer = document.createElement('div');
    mediaContainer.className = 'media media--transparent';

    if (item.image) {
      var imageLink = document.createElement('a');
      imageLink.href = item.url;
      imageLink.className = 'checked-products-card__media-link';
      imageLink.setAttribute('aria-label', item.title || '');

      var img = document.createElement('img');
      img.src = item.image;
      if (item.image_width) {
        img.width = item.image_width;
      }
      if (item.image_height) {
        img.height = item.image_height;
      }
      img.loading = 'lazy';
      img.decoding = 'async';
      img.className = 'motion-reduce';
      img.alt = item.image_alt || item.title || '';

      imageLink.appendChild(img);
      mediaContainer.appendChild(imageLink);
    } else if (section.dataset.placeholderSvg) {
      mediaContainer.innerHTML = section.dataset.placeholderSvg;
    }

    media.appendChild(mediaContainer);
    var hasTotalInventory = typeof item.total_inventory === 'number' && isFinite(item.total_inventory);
    var isSoldOut = hasTotalInventory ? item.total_inventory <= 0 : item.available === false;
    if (isSoldOut) {
      var soldOutOverlay = document.createElement('div');
      soldOutOverlay.className = 'product-card__sold-out-overlay';
      soldOutOverlay.setAttribute('aria-hidden', 'true');
      var soldOutText = document.createElement('span');
      soldOutText.className = 'product-card__sold-out-text';
      soldOutText.textContent = 'SOLD OUT';
      soldOutOverlay.appendChild(soldOutText);
      media.appendChild(soldOutOverlay);
    }
    inner.appendChild(media);
    card.appendChild(inner);

    var content = document.createElement('div');
    content.className = 'card__content';
    var information = document.createElement('div');
    information.className = 'card__information';

    var heading = document.createElement('h3');
    heading.className = 'card__heading h5';
    var headingLink = document.createElement('a');
    headingLink.className = 'full-unstyled-link';
    headingLink.href = item.url;
    headingLink.textContent = item.title || '';
    heading.appendChild(headingLink);

    var detail = document.createElement('div');
    detail.className = 'card-information';

    if (section.dataset.showVendor === 'true' && item.vendor) {
      var vendor = document.createElement('div');
      vendor.className = 'caption-with-letter-spacing light';
      vendor.textContent = item.vendor;
      detail.appendChild(vendor);
    }

    if (item.price_html) {
      var priceWrapper = document.createElement('div');
      priceWrapper.className = 'checked-products-card__price';
      priceWrapper.innerHTML = item.price_html;
      detail.appendChild(priceWrapper);
    }

    var buttonContainer = document.createElement('div');
    buttonContainer.className = 'card__detail-button';
    var button = document.createElement('a');
    button.className = 'button button--secondary button--full-width';
    button.href = item.url;
    button.textContent = section.dataset.viewDetailsText || 'View details';
    buttonContainer.appendChild(button);
    detail.appendChild(buttonContainer);

    information.appendChild(heading);
    information.appendChild(detail);
    content.appendChild(information);
    card.appendChild(content);

    var badgeWrapper = createBadge(item, section);
    if (badgeWrapper) {
      card.appendChild(badgeWrapper);
    }

    wrapper.appendChild(card);
    gridItem.appendChild(wrapper);
    return gridItem;
  }

  function createBadge(item, section) {
    var badgeText = null;
    var badgeColor = '';
    if (
      section.dataset.saleBadgeText &&
      item.compare_at_price &&
      item.price &&
      Number(item.compare_at_price) > Number(item.price)
    ) {
      badgeText = section.dataset.saleBadgeText;
      badgeColor = section.dataset.saleBadgeColor || '';
    }

    if (!badgeText) return null;

    var badgeWrapper = document.createElement('div');
    badgeWrapper.className = 'card__badge ' + (section.dataset.badgePosition || 'bottom-left');
    var badge = document.createElement('span');
    badge.className = 'badge badge--bottom-left';
    if (badgeColor) {
      badge.className += ' ' + badgeColor;
    }
    badge.textContent = badgeText;
    badgeWrapper.appendChild(badge);
    return badgeWrapper;
  }

  function handleShopifySectionEvent(event) {
    if (!event || !event.detail || !event.detail.sectionId) return;
    var section = document.querySelector(
      '[data-checked-products][data-section-id="' + event.detail.sectionId + '"]'
    );
    if (section) {
      renderSection(section, getStoredItems());
    }
  }

  ready(function () {
    recordCurrentProduct();
    renderAllSections();
  });

  document.addEventListener('shopify:section:load', handleShopifySectionEvent);
  document.addEventListener('shopify:section:select', handleShopifySectionEvent);
})();
